import React, {useRef, useEffect} from "react";
import {Swiper, SwiperSlide} from "swiper/react";
import {Pagination} from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./NewPlans.scss";
import mt5 from "../../../assets/icons/MT5.png";
import matchTrader from "../../../assets/icons/MatchTrader.svg";

const MobilePlans = ({challenges, selectedChallengeId, setSelectedChallengeId, handleBuyNow, selectedStepType, selectedPlanName}) => {
  const swiperRef = useRef(null);

  useEffect(() => {
    if (swiperRef.current && selectedChallengeId && challenges.length > 0) {
      const index = challenges.findIndex((c) => c.id === selectedChallengeId);
      if (index !== -1) {
        const currentIndex = swiperRef.current.activeIndex;
        if (currentIndex !== index) {
          swiperRef.current.slideTo(index);
        }
      }
    }
  }, [selectedChallengeId, challenges]);

  const currentChallenge = challenges.find((c) => c.id === selectedChallengeId) || challenges[0];

  return (
    <div className="mobile-plans-container">
      <Swiper
        modules={[Pagination]}
        className="mobile-plans-swiper"
        slidesPerView={1}
        spaceBetween={16}
        centeredSlides
        centeredSlidesBounds
        pagination={{clickable: true}}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        onSlideChange={(swiper) => {
          const activeChallenge = challenges[swiper.activeIndex];
          if (activeChallenge && activeChallenge.id !== selectedChallengeId) {
            setSelectedChallengeId(activeChallenge.id);
          }
        }}
      >
        {challenges.map((challenge) => (
          <SwiperSlide key={challenge.id}>
            <div className={`mobile-plan-card ${selectedChallengeId === challenge.id ? "active" : ""}`}>
              {/* <div className="card-header">
                <h2>{`$${(challenge.starting_balance / 1000).toFixed(challenge.starting_balance % 1000 === 0 ? 0 : 1)}k`}</h2>
              </div> */}
              <div className="card-body">
                {(() => {
                  const getRows = () => {
                    if (selectedStepType === "pro_edge") {
                      return [
                        {label: "Trading Period", value: "Unlimited"},
                        {label: "Minimum Trading Days", value: challenge?.min_trading_days ? `${challenge.min_trading_days} days` : "N/A"},
                        {label: "Maximum Daily Loss", value: challenge?.max_daily_loss ? `${parseFloat(challenge.max_daily_loss).toFixed(0)}%` : "N/A"},
                        {label: "Maximum  Loss (Trailing)", value: challenge?.max_loss ? `${parseFloat(challenge.max_loss).toFixed(0)}%` : "N/A"},
                        {label: "Consistency Score", value: challenge?.consistency_score ? `${challenge.consistency_score}%` : "N/A"},
                        {label: "Platforms", value: "MT5 / Match-Trader"},
                        {
                          label: "Max risk",
                          value: challenge?.max_risk_at_open_position ? `${parseFloat(challenge.max_risk_at_open_position).toFixed(0)}%` : "N/A",
                        },
                        {
                          label: "Safety Cushion",
                          value: challenge?.safety_cushion_percentage ? `${parseFloat(challenge.safety_cushion_percentage).toFixed(0)}%` : "N/A",
                        },
                        {
                          label: "Inactivity Rule",
                          value: challenge?.inactivity_days ? `${challenge.inactivity_days} Days` : "N/A",
                        },
                        {label: "Leverage", value: challenge?.leverage ? `Up to 1 : ${challenge.leverage}` : "N/A"},
                      ];
                    }

                    const rows = [
                      {label: "Trading Period", value: "Unlimited"},
                      {label: "Minimum Trading Days", value: challenge?.min_trading_days ? `${challenge.min_trading_days} days` : "N/A"},
                      {label: "Maximum Daily Loss", value: challenge?.max_daily_loss ? `${parseFloat(challenge.max_daily_loss).toFixed(0)}%` : "N/A"},
                      {
                        label: selectedStepType === "2_step" ? "Maximum Loss" : "Maximum Loss (Trailing)",
                        value: challenge?.max_loss ? `${parseFloat(challenge.max_loss).toFixed(0)}%` : "N/A",
                      },
                    ];

                    // Add Profit Target row
                    if (selectedStepType === "2_step") {
                      // For 2-step: Show "Profit Target" with both phase values
                      const phase1Value = challenge?.profit_target_1 ? `${parseFloat(challenge.profit_target_1).toFixed(0)}%` : "N/A";
                      const phase2Value = challenge?.profit_target_2 ? `${parseFloat(challenge.profit_target_2).toFixed(0)}%` : "N/A";
                      rows.push({
                        label: "Profit Target",
                        value: `Phase 1: ${phase1Value} / Phase 2: ${phase2Value}`,
                      });
                    } else {
                      // For 1-step: Show "Profit Target" with just the value
                      rows.push({
                        label: "Profit Target",
                        value: challenge?.profit_target_1 ? `${parseFloat(challenge.profit_target_1).toFixed(0)}%` : "N/A",
                      });
                    }

                    rows.push({label: "Platforms", value: "MT5 / Match-Trader"}, {label: "Leverage", value: challenge?.leverage ? `Up to 1 : ${challenge.leverage}` : "N/A"});

                    return rows;
                  };

                  return getRows().map((row, idx) => (
                    <div
                      className="feature-item"
                      key={idx}
                    >
                      <span className="feature-label">{row.label}</span>
                      {row.label === "Platforms" ? (
                        <span className="feature-value platforms">
                          <span className="platform-item">
                            <img
                              src={mt5}
                              alt="MT5"
                            />
                            MetaTrader 5
                          </span>
                          <span className="platform-item">
                            <img
                              src={matchTrader}
                              alt="matchTrader"
                            />
                            Match-Trader
                          </span>
                        </span>
                      ) : (
                        <span className="feature-value">{row.value}</span>
                      )}
                    </div>
                  ));
                })()}
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Buy Now Button - Outside the carousel */}
      <div className="mobile-buy-button-container">
        <button
          className="mobile-buy-button"
          onClick={() => handleBuyNow(currentChallenge)}
        >
          <span className="btn-text">
            Buy Now - ${Number(currentChallenge?.price || 0).toFixed(0)}
          </span>
        </button>
      </div>
    </div>
  );
};

export default MobilePlans;
